import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Header } from './header.model';
import { Router, Route, ActivationStart } from '@angular/router';
import * as _ from 'lodash';
import { BaseObserver } from '../../shared/baseobserver';
import { takeUntil } from 'rxjs/operators';
import { ES5ZoneAwareRouter } from '../../elements-routing/es5ZoneAwareRouter';

@Injectable()
export class HeaderService extends BaseObserver {

  private _header: Header = new Header();
  public readonly header: BehaviorSubject<Header> = new BehaviorSubject<Header>(this._header);
  public readonly navEvents: BehaviorSubject<() => Promise<boolean>> = new BehaviorSubject<() => Promise<boolean>>(null);

  constructor(
    private readonly router: Router,
    private readonly es5Router: ES5ZoneAwareRouter
  ) {
    super();
    this.updateFromRouterNavigation();
  }

  private static constructHeaderForRoute(routerConfig: Route[], routerHeader: Partial<Header>, override: Partial<Header> = {}): Header {
    const header = {
      ultiProHelpPageName: override.ultiProHelpPageName || routerHeader.ultiProHelpPageName,
      pageTitle: override.pageTitle || routerHeader.pageTitle,
      pageTooltip: override.pageTooltip || routerHeader.pageTooltip,
      breadcrumb: override.breadcrumb || routerHeader.breadcrumb,
      breadcrumbs: routerHeader.breadcrumbs,
      breadcrumbTrail: override.breadcrumbTrail || (routerHeader.breadcrumbs || []).map(crumb => {
        if (typeof crumb === 'string') {
          const route = _.find(routerConfig, (configuredRoute) => configuredRoute.path === crumb);

          return { pageTitle: route.data.header.breadcrumb, link: route.path };
        }

        return crumb;
      }),
      customBackLink: override.customBackLink || null,
    } as Header;

    return header;
  }

  private updateFromRouterNavigation() {
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (event instanceof ActivationStart) {
          this.header.next(HeaderService.constructHeaderForRoute(this.router.config, event.snapshot.data.header || {}));
        }
    });
  }

  /** navigate to route, optionally with header overrides for breadcrumbs.
   * @param commands forwarded to router.navigate
   * @param headerOverrides hook used to override the header displayed after navigation. */
  navigate(commands: any[], headerOverrides: Partial<Header> = null): void {

    if (headerOverrides) {
      this.es5Router.navigate(commands)
        .then(() => this.header.next(HeaderService.constructHeaderForRoute(this.router.config, this.header.value, headerOverrides)));
    } else {
      this.es5Router.navigate(commands);
    }
  }
}
